import { TransactionStatus } from '../data/Transaction'

export const isNexiTransactionFinished = (status: number): boolean =>
    status === TransactionStatus.CLOSED_NOT_PROCESSED ||
    status === TransactionStatus.MISSING_NOT_PROCESSED ||
    status === TransactionStatus.CLOSED ||
    status === TransactionStatus.MISSING
